module.exports = __webpack_public_path__ + "img/2.3da2f18d.png";